import React from 'react';
import './Whip.css';
import { FaCar } from 'react-icons/fa';

const Whip = () => {
    return (
        <div className="whip-container">
            <div className="whip-header">
                <FaCar className="whip-icon" />
                <div className="whip-title-section">
                    <span className="whip-label">My Ride</span>
                    <h1 className="whip-title">2026 Tesla Model 3</h1>
                    <p className="whip-subtitle">Red • Long Range • Interactive 3D View</p>
                </div>
            </div>

            <div className="whip-model-container">
                <div className="sketchfab-embed-wrapper">
                    <iframe
                        title="Tesla Model 3 Red"
                        frameBorder="0"
                        allowFullScreen
                        mozallowfullscreen="true"
                        webkitallowfullscreen="true"
                        allow="autoplay; fullscreen; xr-spatial-tracking"
                        src="https://sketchfab.com/models/3a602469d7874d1397efa67182198705/embed?autostart=1&ui_controls=1&ui_infos=0&ui_inspector=0&ui_stop=0&ui_watermark=0&ui_hint=0"
                    />
                </div>
                <p className="whip-hint">Click and drag to rotate • Scroll to zoom</p>
            </div>

            <div className="whip-specs">
                <div className="spec-card">
                    <span className="spec-value">283</span>
                    <span className="spec-label">Miles Range</span>
                </div>
                <div className="spec-card">
                    <span className="spec-value">5.8s</span>
                    <span className="spec-label">0-60 mph</span>
                </div>
                <div className="spec-card">
                    <span className="spec-value">140</span>
                    <span className="spec-label">Top Speed</span>
                </div>
                <div className="spec-card">
                    <span className="spec-value">AWD</span>
                    <span className="spec-label">Dual Motor</span>
                </div>
            </div>
        </div>
    );
};

export default Whip;
